import React from 'react';

type InputProps = {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
} & Omit<React.ComponentPropsWithRef<'input'>, 'className'>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, icon, ...props }, ref) => {
    const id = React.useId();

    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-gray-700">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
              {icon}
            </div>
          )}
          <input
            id={id}
            ref={ref}
            className={`
              block w-full rounded-md border-gray-300 shadow-sm py-2.5
              focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
              ${icon ? 'pl-10' : ''} 
              ${error ? 'border-red-300' : ''} 
            `}
            {...props}
          />
        </div>
        {helperText && !error && (
          <p className="text-sm text-gray-500 mt-1">{helperText}</p>
        )}
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';